export default "__VITE_ASSET__DpmycOgU__"